<template>
  <div>
    <label>{{ label }}</label>
    <AtTCCheckbox
      v-if="routeLabel"
      v-bind="$attrs"
      :route-label="routeLabel"
      :to="to"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import { AtTCCheckbox } from '@/components/base/atoms/input/AtTCCheckbox'
import i18n from '@/plugins/i18n'

export default {
  name: 'TTCPolicyCheckbox',

  components: { AtTCCheckbox },

  props: {
    label: {
      type: String,
      default: i18n.t('components.TTCPolicyCheckbox.label')
    },
    policyCode: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      routeLabel: null,
      to: {}
    }
  },

  async mounted () {
    await this.storeApiDispatch('S0901Policy/doRead', { policy_code: this.policyCode }).then((data) => {
      console.log(data)
      const result = data[0].output

      this.routeLabel = result.policy_name
      this.to = { name: 'S0901View', params: { id: result.id } }
    })
  }
}
</script>
